import { persistTrackingData } from '../util';
import { initDataLayer } from '../util/initDataLayer';
import { isBrowser } from '../util/isBrowser';
import { pushFilterNoResults } from '../filters/pushFilterNoResults';
export function pushHotelSearchResults(data) {
    var _a, _b, _c, _d;
    if (!isBrowser())
        return;
    initDataLayer();
    const message = {
        hotelSearchResults: (_a = data.hotelSearchResults) === null || _a === void 0 ? void 0 : _a.hotels.map((hotelSearchResult, index) => {
            var _a, _b, _c;
            const { hotel, pricingSummary } = hotelSearchResult;
            return {
                estabId: hotel.estabId,
                name: hotel.name,
                country: (_a = hotel.geography) === null || _a === void 0 ? void 0 : _a.country,
                region: (_b = hotel.geography) === null || _b === void 0 ? void 0 : _b.province,
                price: pricingSummary.price,
                position: index + 1,
                boardOption: pricingSummary.boardTypeDescription,
                promotion: (_c = pricingSummary.callout) === null || _c === void 0 ? void 0 : _c.text.join(' '),
                starRating: hotel.starRating,
            };
        }),
        totalResults: (_b = data.hotelSearchResults) === null || _b === void 0 ? void 0 : _b.hotelCount,
        filteredResults: (_c = data.hotelSearchResults) === null || _c === void 0 ? void 0 : _c.filteredHotelCount,
    };
    window.dataLayer.push(Object.assign({ event: 'hotelSearchResultsLoaded' }, message));
    if (!((_d = data.hotelSearchResults) === null || _d === void 0 ? void 0 : _d.filteredHotelCount)) {
        pushFilterNoResults();
    }
    persistTrackingData(message);
}
